import { Card } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Clock, AlertCircle, Sparkles } from "lucide-react"
import { PageLayout } from "./PageLayout"
import logo from "@/assets/logo-25segundos-horizontal.png"

interface PreTestGuidanceProps {
  onContinue: () => void
  onBack: () => void
}

export function PreTestGuidance({ onContinue, onBack }: PreTestGuidanceProps) {
  return (
    <PageLayout>
      <div className="w-full max-w-2xl">
        <Card className="w-full p-6 md:p-8 shadow-elegant">
          <div className="space-y-4">
            <div className="flex justify-center mb-4">
              <img src={logo} alt="25Segundos" className="h-14 md:h-16" />
            </div>

            <div className="text-center mb-6">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gradient-primary mb-3">
                <Clock className="w-7 h-7 text-primary-foreground" />
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-title-blue">
                ⏳ Antes de começar seu Teste Vocacional
              </h2>
            </div>

            <div className="bg-accent/10 rounded-lg p-5 space-y-3">
              <p className="text-muted-foreground leading-relaxed text-sm md:text-base">
                Este teste foi pensado para te ajudar a conhecer melhor suas tendências,
                inclinações e caminhos possíveis para o futuro.
              </p>
              <p className="text-muted-foreground leading-relaxed text-sm md:text-base">
                Para que o resultado seja fiel e completo, é importante que você realize
                todas as etapas de uma só vez.
              </p>
            </div>

            <div className="space-y-3">
              <div className="flex items-start gap-3 p-3 bg-background rounded-lg border">
                <Clock className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <p className="text-sm text-muted-foreground">
                  Reserve de 20 a 30 minutos do seu tempo, dependendo do seu ritmo.
                </p>
              </div>

              <div className="flex items-start gap-3 p-3 bg-background rounded-lg border">
                <AlertCircle className="w-5 h-5 text-brand-orange mt-0.5 flex-shrink-0" />
                <p className="text-sm text-muted-foreground">
                  Não é possível pausar, sair e voltar depois.
                </p>
              </div>

              <div className="flex items-start gap-3 p-3 bg-background rounded-lg border border-destructive/30">
                <AlertCircle className="w-5 h-5 text-destructive mt-0.5 flex-shrink-0" />
                <p className="text-sm text-muted-foreground">
                  Caso você interrompa o processo, será necessário iniciar novamente e criar
                  um novo cadastro.
                </p>
              </div>
            </div>

            <div className="bg-gradient-primary/10 rounded-lg p-5 text-center space-y-2">
              <Sparkles className="w-6 h-6 text-primary mx-auto mb-1" />
              <p className="text-muted-foreground font-medium text-sm md:text-base">
                Prepare um ambiente tranquilo, respire fundo… e siga no seu tempo.
              </p>
              <p className="text-sm text-muted-foreground italic">
                Este momento é seu. Escolha com presença.
              </p>
            </div>

            <div className="flex gap-3 pt-2">
              <Button
                type="button"
                onClick={onBack}
                variant="outline"
                size="lg"
                className="flex-1"
              >
                Voltar
              </Button>
              <Button
                onClick={onContinue}
                className="flex-1 bg-gradient-primary hover:opacity-90 transition-opacity"
                size="lg"
              >
                Estou pronto(a)
              </Button>
            </div>
          </div>
        </Card>
      </div>
    </PageLayout>
  )
}
